import { apiClient } from "@nabble/sdk";

export interface AccountSession {
  handle: string;
  createdAt: string;
  lastAccessedAt: string;
  current: boolean;
}

export function closeSession(handle: string): Promise<void> {
  return apiClient<void>(`/api/account/sessions/${handle}`, { method: "DELETE" });
}
